import { useSearchParams } from "wouter"

import { CART_ITEM_ID_SEARCH_PARAM_NAME } from "@/config"

const useCartItemIdParam = () => {
  const [searchParams] = useSearchParams()
  const cartItemId = searchParams.get(CART_ITEM_ID_SEARCH_PARAM_NAME)
  return { cartItemId }
}

export default useCartItemIdParam
